import { render } from "./ValidateInput2.vue?vue&type=template&id=f10fdf56"
import script from "./ValidateInput2.vue?vue&type=script&lang=js"
export * from "./ValidateInput2.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../CASRA/saoil/webadmin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__